import React, { useState, useEffect } from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet, ScrollView,TextInput, Linking, Dimensions } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import  Colors  from './constants/Colors';
import MenuPanel from './menuPanel';

import productTypeList from './lib/productTypeList';
import Item from './lib/item'
import NavBar from './navBar'; 
import CustomButton from './components/CustomButton';
import Taglia  from './assets/images/taglia.png'; 
import close from './assets/icons/close.png'; 
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// Supponiamo che l'altezza della barra di navigazione sia di 60px
const HEADER_HEIGHT = 60;
// Supponiamo che l'altezza della tua view in fondo sia di 100px
const BOTTOM_VIEW_HEIGHT = 120;


const { width, height } = Dimensions.get('window');
const Product = () => {

  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const location = useLocation();
  const [currentItem, setCurrentItem] = useState(location.state?.currentItem || null); // Stato per currentItem
  const [data, setData] = useState([]);
    // Effettua il fetch se currentItem è ancora null

    const fetchData = async () => {
      if(loading){
      try {
        const response = await fetch('/proxy.php'); // URL del server proxy
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jsonData = await response.json(); // Leggi i dati JSON restituiti dal server
        console.log(jsonData); // Stampa i dati
  
        //const result = await response.json(); // Supponendo che il server restituisca JSON
        setData(jsonData); // Aggiorna lo stato con i dati ricevuti
        console.log('Request sent successfully');
      } catch (err) {
       // setError(err.message);
      } finally {
        setLoading(false);
        
      }
    }
    };

    useEffect(() => {
      // Fetch data only if not already loaded
      if (loading && data.length === 0) {
        fetchData();
      }
    }, [loading, data]);

    useEffect(() => {
      console.log("currentITEM:", currentItem);
    }, [currentItem]); // Questo si attiva ogni volta che currentItem cambia

if(currentItem == null){
  if(data.length > 0){
    data.forEach((row) => {
      // Crea un nuovo oggetto Item per ogni riga
      const idRow = row.id;
      if (Number(id) === idRow) {
       // idToMatch è l'id con cui vuoi confrontare
       const id = row.productTypeList;
      const type = productTypeList[id];
  
      const newItem = new Item(
        type,  // prodotto (modifica se necessario)
        row.numberS,      // quantità per taglia S
        row.numberM,      // quantità per taglia M
        row.numberL       // quantità per taglia L
      );
      setCurrentItem(newItem);
      console.log("currentITEM:", currentItem);
    // Puoi aggiungere `newItem` a una lista se necessario
      }
    });
  }else{
    fetchData();
  }
}

    
  const [showHelpButton, setShowHelpButton] = useState(true);  // Stato per mostrare/nascondere il bottone

  const handleReset = () => {
    setShowEmail(false);  // Nascondi la sezione di contatto
    setShowHelpButton(true);  // Mostra di nuovo il bottone di aiuto
  };
  const [menuVisible, setMenuVisible] = useState(false);
  const [confirmEmailSendVisible, setConfirmEmailSendVisibleVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);
   // Stati per controllare l'apertura delle sezioni
   const [expandedSection, setExpandedSection] = useState(null);
   const [showEmail, setShowEmail] = useState(false);
 
   // Funzione per gestire l'apertura/chiusura delle sezioni
   const toggleSection = (section) => {
     setExpandedSection(expandedSection === section ? null : section);
   };

const navigate = useNavigate();

  const TestMailCheckout = async () => {

console.log('email: '+  shippingData.email + ' nmessage '+  shippingData.message);
    try {
      const message = `Dati del prodotto: Nome: ${String(productType.name)}  Prezzo: € ${String(productType.price)} Email-Cliente: ${String(shippingData.email)} Message: ${String(shippingData.message)}`;

      const response = await fetch('/sendEmailForInfo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subject: 'Informazioni',
          message:  message,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const jsonData = await response.json();
      setConfirmEmailSendVisibleVisible(true);
      setShippingData((prevState) => ({ ...prevState, 
        message: ' ', 
      }));
     console.error('Email inviata con successo', jsonData );
    } catch (error) {
      console.error('Errore nell\'invio dell\'email:', error);
     
    }
  };
  const [currentIndex, setCurrentIndex] = useState(0); 
  const [selectedSize, setSelectedSize] = useState(null);
  const [taglie] = useState(['S', 'M', 'L']);

  // Stato per valori derivati
  const [availableSizes, setAvailableSizes] = useState([]);
  const [productType, setProductType] = useState({});

  // Effetto per ricalcolare quando cambia currentItem
  useEffect(() => {
    if (currentItem) {
      // Calcola le taglie disponibili
      const sizes = taglie.filter(size => {
        if (size === 'S') return currentItem.quantityS > 0;
        if (size === 'M') return currentItem.quantityM > 0;
        if (size === 'L') return currentItem.quantityL > 0;
        return false;
      });
      setAvailableSizes(sizes);

      // Imposta il tipo di prodotto
      setProductType(currentItem.productType || {});
    } else {
      // Resetta se currentItem è nullo
      setAvailableSizes([]);
      setProductType({});
    }
  }, [currentItem, taglie]);

  
  //  availableSizes = taglie.filter(size => {
  //   if (size === 'S') return currentItem!=null && currentItem.quantityS > 0;
  //   if (size === 'M') return currentItem!=null && currentItem.quantityM > 0;
  //   if (size === 'L') return currentItem!=null && currentItem.quantityL > 0;
  //   return false;
  // });
  //  productType = currentItem && currentItem.productType ? currentItem.productType : {};
  const handleAddToCart = () => {
    const direction="cart";
    navigate(`/${direction.toLowerCase()}`, { state:  { currentItem, selectedSize }}); // Naviga alla pagina
  };
  const images = [productType.imgPath1, productType.imgPath2];
  console.log("currentWidth è ", width,"windowHeight", height);
  const padding=16;
  const availableHeight = height - HEADER_HEIGHT- BOTTOM_VIEW_HEIGHT;
  const availableWidth = width - padding - padding;
  
  const [shippingData, setShippingData] = useState({
    email: '',
    message: '',
  });

  // Funzione per aggiornare l'indice corrente
  const handleScroll = (event) => {
    const contentOffsetX = event.nativeEvent.contentOffset.x;
    const currentPage = Math.round(contentOffsetX / availableWidth);
    setCurrentIndex(currentPage);
  };


  const handleInputChange = (field, value) => {
    setShippingData(prevData => {
      const updatedData = { ...prevData, [field]: value };
      const allFieldsFilled = Object.values(updatedData).every(fieldValue => fieldValue.trim() !== '');
      return updatedData;
    });
  };


  return (
    <View style={styles.container}>
    {/* NavBar with Menu Button */}

    <NavBar toggleMenu={toggleMenu} />
      <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />
      <View style={styles.header}>
   
      <ScrollView contentContainerStyle={{ paddingBottom: 130, paddingTop:20, paddingHorizontal:20 }}  >
      <View style={{ height: availableHeight }}>
      <ScrollView
      backgroundColor="white"
      horizontal
      onScroll={handleScroll} 
      pagingEnabled // Scorrimento a pagine
      showsHorizontalScrollIndicator={false}
    >
      {images.map((img, index) => (
        <Image
        margin={0}
          key={index}
          source={img}
         
          style={{ height: availableHeight-100 ,width: availableWidth ,  alignSelf: 'center' }}
          resizeMode="contain" // Adatta l'immagine senza tagliarla
        />
      ))}
    </ScrollView>
     {/* Indicatore della pagina corrente */}
     <Text style={styles.indicator}>
        {currentIndex + 1}/{images.length}
      </Text>
       <View style={{marginTop:16, marginBottom:20, paddingBottom:6, borderBottomWidth:1, borderColor: "black", flexDirection: 'row', justifyContent: 'space-between',alignItems: 'center'}}>
  <Text style={{ fontSize: 16, fontWeight: 'bold', justifyContent: 'center' }}>
    {productType.name}
  </Text>
  <Text style={{ fontSize: 16, fontWeight: 'bold' }}>
    € {productType.price}  {/* Assicurati di formattare il prezzo */}
  </Text>
  </View>
      </View>
       

      {/* Sezione Bottoni */}
      <TouchableOpacity style={styles.button} onPress={() => toggleSection('productDescription')}>
        <Text style={styles.buttonText}>Descrizione Prodotto</Text>
        <Text style={styles.buttonText}>
          {expandedSection === 'productDescription' ? '-' : '+'}
        </Text>
      </TouchableOpacity>
      {expandedSection === 'productDescription' && (
        <Text style={styles.sectionContent}>{productType.description}</Text>
      )}

<TouchableOpacity style={styles.button} onPress={() => toggleSection('fit')}>
        <Text style={styles.buttonText}>Taglia e Fit</Text>
        <Text style={styles.buttonText}>
          {expandedSection === 'fit' ? '-' : '+'}
        </Text>
      </TouchableOpacity>
      {expandedSection === 'fit' && (
  <View style={styles.sectionContent}>

    <Image 
      source={Taglia} 
      style={styles.image} 
      alt="Guida alle taglie" 
    />

    <View style={styles.tableContainer}>
      <View style={styles.tableHeader}>
        <Text style={styles.tableHeaderText}></Text>
        <Text style={styles.tableHeaderText}>S</Text>
        <Text style={styles.tableHeaderText}>M</Text>
        <Text style={styles.tableHeaderText}>L</Text>
      </View>
      {[
        { taglia: 'Lunghezza Manica', manica: 64, busto: 66 , corpo: 68 },
        { taglia: 'Lunghezza Busto', manica: 55, busto: 57, corpo: 59 },
        { taglia: 'Lunghezza Corpo', manica: 62, busto: 65, corpo: 68 },
      ].map((row, index) => (
        <View key={index} style={styles.tableRow}>
          <Text style={styles.tableCell}>{row.taglia}</Text>
          <Text style={styles.tableCell}>{row.manica}</Text>
          <Text style={styles.tableCell}>{row.busto}</Text>
          <Text style={styles.tableCell}>{row.corpo}</Text>
        </View>
      ))}
    </View>
  </View>
)}



      {/* Bottone per l'email */}
      {showHelpButton ? (
        <TouchableOpacity style={styles.helpButton} onPress={() => { setShowEmail(true); setShowHelpButton(false); }}>
          <Text style={styles.helpButtonText}>Possiamo aiutarti?</Text>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.resetButton} onPress={handleReset}>

          <Image source={close} style={styles.resetButtonText} />
        </TouchableOpacity>
      )}
      {showEmail &&   <View style={styles.contactContainer}>
      {confirmEmailSendVisible && (
    <Text style={styles.contactTitle}>
      Messaggio inviato con successo con mail: ${String(shippingData.email)}
    </Text>)}
        <Text style={styles.contactTitle}>Inviaci un messaggio</Text>
        
        <TextInput
          style={styles.input}
          placeholder="Email"
          placeholderTextColor="#888"
          onChangeText={text => handleInputChange('email', text)}
        />
        <TextInput
          style={styles.input}
          placeholder="Messaggio"
          placeholderTextColor="#888"
          multiline
          numberOfLines={4}
          onChangeText={text => handleInputChange('message', text)}
        />

        <TouchableOpacity style={styles.contattaciButton} onPress={TestMailCheckout}>
          <Text style={styles.contattaciText}>Contattaci</Text>
        </TouchableOpacity>
      </View>}
 
    
      </ScrollView>
         {/* Fixed Bottom Section */}
        
         <View style={styles.bottomContainer}>
        <View style={{ 
    flexDirection: 'row',alignItems: 'center' }}>
  {/* Sezione delle taglie */}
  {taglie.map((size) => (
    <TouchableOpacity
      key={size}
      onPress={() => setSelectedSize(size)}
      disabled={!availableSizes.includes(size)}
      style={{
        width: 60, // Larghezza fissa per i pulsanti delle taglie
        height: 50, // Stessa altezza delle taglie
        marginHorizontal: 5,
        borderWidth: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: selectedSize === size ? '#000' : '#fff',
        opacity: availableSizes.includes(size) ? 1 : 0.5,
      }}
    >
      <Text
    style={{
      fontSize: 16,
      color: !availableSizes.includes(size)
        ? '#aaa'  // Colore per taglie non disponibili
        : selectedSize === size
        ? '#fff'  // Colore bianco se la taglia è selezionata
        : '#000', // Colore nero se la taglia non è selezionata
    }}
  >
    {size}
  </Text>
    </TouchableOpacity>
  ))}

        </View>
        <View style={{ justifyContent: 'center', flex:1  }}>
          <CustomButton
    title="Aggiungi"
    handlePress={handleAddToCart}
    isDisabling={!selectedSize}
    currentHeight= {50}
    currentBorderRadius= {0}
    style={{
      backgroundColor: selectedSize ? '#000000' : '#ccc',
      justifyContent: 'center',
      alignItems: 'center',
     
    }}
  />
</View>


        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flex: 1,
  },
  productInfo:{
    height:'100%',
  },
  header: {
    flex: 1,
    marginTop: 60,
    backgroundColor: '#ffffff',
  },
  bottomContainer: {
    width: '100%' ,
    flexDirection: 'row',
    height:BOTTOM_VIEW_HEIGHT,
    padding: 20,
    margin:0,
    backgroundColor: '#fff',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    borderTopWidth: 1,
    borderBottomColor: '#F0F0F0', // Colore chiarissimo della linea
  },
  bulletList: {
    marginLeft: 16,
  },
  bulletItem: {
    fontSize: 12,
    color: '#666',
    marginBottom: 4,
  },

  container: {
    flex: 1,
  },
  button: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    marginBottom: 8,
  },
  buttonText: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  sectionContent: {
    padding: 16,
    backgroundColor: '#f9f9f9',
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    marginBottom: 8,
  },
  helpButton: {
    marginTop: 16,
    padding: 8,
    borderWidth: 1,
    borderRadius: 4,
    borderColor:  '#000000',
  },
  helpButtonText: {
    color: '#000000',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
  },
  emailText: {
    marginTop: 8,
    textAlign: 'center',
    fontSize: 12,
    color: '#333',
  },
  contactTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  input: {
    height: 45,
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 15,
    paddingLeft: 10,
    fontSize: 12,
    backgroundColor: '#fafafa',
  },
  contattaciButton: {
    backgroundColor: '#000', // Colore di WhatsApp
    borderRadius: 5,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contattaciText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  resetButton: {
    backgroundColor: '#ffffff',  // Colore per il bottone di reset
    padding: 10,
    borderRadius: 5,
    alignItems: 'flex-end'
  },
  image: {
    width: 200,
    height: 200,
    resizeMode: 'contain',
    marginVertical: 15,
  },
  tableContainer: {
    marginTop: 20,
    borderWidth: 1,
    borderColor: '#ccc',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#ddd',
    paddingVertical: 5,
  },
  tableHeaderText: {
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 14,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingVertical: 5,
  },
  tableCell: {
    flex: 1,
    textAlign: 'center',
    fontSize: 14,
  },
  indicator: {
    textAlign: 'center',
    marginTop: 0,
    fontSize: 16,
    fontWeight: '200',
    color: 'black',
  },
});

export default Product;
